module.exports = __webpack_public_path__ + "static/media/poc-dashboard-user-icon.c3d27f71.svg";